import React, { useState } from 'react';
import { COLORS, FONTS, primaryButtonStyle } from '../signup/signupStyles';

const CONDITIONS = [
  { name: 'Lupus', icon: '🦋', activity: '16 questions answered' },
  { name: 'Narcolepsy', icon: '💤', activity: '16 questions answered' },
  { name: 'Polycythemia Vera', icon: '🩸', activity: '16 questions answered' },
  { name: 'Cystic Fibrosis', icon: '🫁', activity: 'New community' },
];

const ConditionCard = ({ condition, selected, onClick }) => (
  <button onClick={onClick} style={{
    display: 'flex', alignItems: 'center', gap: '14px',
    width: '100%', padding: '16px 20px', backgroundColor: '#fff',
    border: selected ? `2px solid ${COLORS.text}` : `1.5px solid ${COLORS.border}`,
    borderRadius: '6px', cursor: 'pointer', textAlign: 'left',
    transition: 'all 0.15s'
  }}>
    <span style={{ fontSize: '24px' }}>{condition.icon}</span>
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: '15px', fontWeight: '600', color: COLORS.text }}>
        {condition.name}
      </div>
      <div style={{ fontSize: '13px', color: COLORS.muted }}>
        {condition.activity}
      </div>
    </div>
    {selected && (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke={COLORS.text} strokeWidth="2.5" strokeLinecap="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    )}
  </button>
);

export const ConditionSelect = ({ onSelect }) => {
  const [selected, setSelected] = useState(null);

  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
      fontFamily: FONTS.system
    }}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div style={{
        maxWidth: '440px', width: '100%', animation: 'fadeUp 0.6s ease-out'
      }}>
        <div style={{
          background: '#fff', borderRadius: '12px',
          boxShadow: '0 4px 40px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.02)',
          padding: '40px 36px'
        }}>
          <h1 style={{
            fontFamily: FONTS.serif, fontSize: 'clamp(22px, 5vw, 28px)',
            fontWeight: 700, color: COLORS.text, textAlign: 'center',
            margin: '0 0 8px', lineHeight: 1.3
          }}>
            Hear from patients like you.
          </h1>
          <p style={{
            fontSize: '15px', color: COLORS.muted, textAlign: 'center',
            margin: '0 0 28px', lineHeight: 1.5
          }}>
            Pick your condition and see what others are saying — no account needed.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '24px' }}>
            {CONDITIONS.map(c => (
              <ConditionCard key={c.name} condition={c}
                selected={selected === c.name}
                onClick={() => setSelected(c.name)} />
            ))}
          </div>

          <button onClick={() => selected && onSelect(selected)}
            disabled={!selected}
            style={{
              ...primaryButtonStyle, width: '100%', padding: '16px 24px',
              opacity: selected ? 1 : 0.4,
              cursor: selected ? 'pointer' : 'not-allowed'
            }}>
            See What They're Saying
          </button>
        </div>
      </div>
    </div>
  );
};
